import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IncludedInModule } from '@portal-core/general/pipes/included-in/included-in.module';
import { TeamAvatarModule } from '@portal-core/teams/components/team-avatar/team-avatar.module';
import { ListModule } from '@portal-core/ui/list/list.module';
import { SiteTeamsListComponent } from './site-teams-list.component';


@NgModule({
  declarations: [
    SiteTeamsListComponent
  ],
  imports: [
    CommonModule,
    ListModule,
    IncludedInModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    MatSnackBarModule,
    MatTooltipModule,
    TeamAvatarModule,
  ],
  exports: [
    SiteTeamsListComponent
  ]
})
export class SiteTeamsListModule { }
